  (function () {
    /**
     * Los precios que pinta el JS deben verse igual que los que pinta Liquid,
     * asi que se formatean con el mismo shop.money_format de la tienda, que
     * theme.liquid expone en window.AnubisShop.
     *
     * Apoyarse en el idioma del visitante no sirve: con la tienda en ingles,
     * Intl daba "CLP 37,990" donde Liquid daba "$37.990".
     */
    function formatShopMoney(amount) {
      const shop = (typeof window !== 'undefined' && window.AnubisShop) || {};
      const format = shop.moneyFormat || '${{amount_no_decimals}}';
      const token = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';

      let miles = ',';
      let decimal = '.';
      if (token.indexOf('comma_separator') !== -1) {
        miles = '.';
        decimal = ',';
      } else if (token.indexOf('apostrophe_separator') !== -1) {
        miles = "'";
      } else if (token.indexOf('space_separator') !== -1) {
        miles = ' ';
        decimal = ',';
      }

      const numero = Number(amount) || 0;
      const texto = token.indexOf('no_decimals') !== -1 ? String(Math.round(numero)) : numero.toFixed(2);
      const partes = texto.split('.');
      const entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      const valor = partes[1] ? entero + decimal + partes[1] : entero;

      return format.replace(/\{\{\s*\w+\s*\}\}/, valor);
    }

    // Compatible con el uso previo: .format(importe)
    function activeMoneyFormatter() {
      return { format: formatShopMoney };
    }

    function runWhenVisible(node, callback, rootMargin = '240px 0px') {
      if (!node || typeof callback !== 'function') return;
      if (!('IntersectionObserver' in window)) {
        callback();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.disconnect();
              callback();
            }
          });
        },
        { rootMargin }
      );

      observer.observe(node);
    }

    function formatCountdown(ms) {
      if (ms <= 0) return '00:00:00:00';
      const total = Math.floor(ms / 1000);
      const d = Math.floor(total / 86400);
      const h = Math.floor((total % 86400) / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(d)}:${pad(h)}:${pad(m)}:${pad(s)}`;
    }

    function initCountdown(root) {
      const timers = root.querySelectorAll('[data-countdown]');
      if (!timers.length) return;
      let intervalId = null;

      const tick = () => {
        const now = Date.now();
        timers.forEach((node) => {
          const end = node.getAttribute('data-end');
          const value = node.querySelector('strong');
          if (!end || !value) return;
          const ms = new Date(end).getTime() - now;
          value.textContent = formatCountdown(ms);
        });
      };

      const start = () => {
        if (intervalId) return;
        tick();
        intervalId = window.setInterval(tick, 1000);
      };

      const stop = () => {
        if (!intervalId) return;
        window.clearInterval(intervalId);
        intervalId = null;
      };

      start();
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
          return;
        }
        start();
      });
    }

    function initHeroCarousel(root) {
      const carousel = root.querySelector('[data-hero-carousel]');
      if (!carousel) return;

      const slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
      const prevButton = carousel.querySelector('[data-hero-prev]');
      const nextButton = carousel.querySelector('[data-hero-next]');

      if (slides.length < 2) return;

      const autoDelayMs = 6500;
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let current = 0;
      let timer = null;

      const setActive = (nextIndex) => {
        current = (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const active = index === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach((dot, index) => {
          const active = index === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
          dot.setAttribute('tabindex', active ? '0' : '-1');
        });
      };

      const stopAuto = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const startAuto = () => {
        if (reduceMotion || document.hidden) return;
        stopAuto();
        timer = window.setInterval(() => {
          setActive(current + 1);
        }, autoDelayMs);
      };

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          setActive(current - 1);
          startAuto();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          setActive(current + 1);
          startAuto();
        });
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          setActive(index);
          startAuto();
        });
      });

      let touchStartX = 0;
      let touchStartY = 0;

      carousel.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        stopAuto();
      }, { passive: true });

      carousel.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;

        if (Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
          setActive(current + (deltaX < 0 ? 1 : -1));
        }

        startAuto();
      }, { passive: true });

      carousel.addEventListener('mouseenter', stopAuto);
      carousel.addEventListener('mouseleave', startAuto);
      carousel.addEventListener('focusin', stopAuto);
      carousel.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!carousel.contains(document.activeElement)) {
            startAuto();
          }
        }, 0);
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAuto();
          return;
        }
        startAuto();
      });

      setActive(0);
      startAuto();
    }

    /**
     * Primera tarjeta del carrusel que ocupa espacio de verdad.
     *
     * No sirve track.firstElementChild: dedupeCarouselsAcrossPage() marca
     * como hidden las tarjetas repetidas entre carruseles, y una tarjeta
     * oculta mide 0 de ancho. Si midieramos esa, el paso saldria de unos
     * pocos pixeles y las flechas apenas moverian el carrusel.
     *
     * Devuelve null si no queda ninguna visible; quien llama usa entonces
     * su propio valor por defecto.
     */
    function firstVisibleCard(track) {
      if (!track) return null;
      const cards = track.children;
      for (let i = 0; i < cards.length; i += 1) {
        const card = cards[i];
        if (card.hidden) continue;
        if (card.getBoundingClientRect().width > 0) return card;
      }
      return null;
    }

    function initOffersCarousel(root) {
      const carousels = root.querySelectorAll('[data-offers-carousel]');
      if (!carousels.length) return;

      carousels.forEach((carousel) => {
        const track = carousel.querySelector('[data-offers-track]');
        const prevButton = carousel.querySelector('[data-offers-prev]');
        const nextButton = carousel.querySelector('[data-offers-next]');
        if (!track || !prevButton || !nextButton) return;

        const getStep = () => {
          const firstCard = firstVisibleCard(track);
          if (!firstCard) return 320;
          const style = window.getComputedStyle(track);
          const gap = Number.parseFloat(style.columnGap || style.gap || '0') || 0;
          return Math.max(1, Math.round(firstCard.getBoundingClientRect().width + gap));
        };

        const updateButtons = () => {
          const maxScroll = Math.max(0, Math.ceil(track.scrollWidth - track.clientWidth));
          const step = getStep();
          const visibleApprox = Math.max(1, Math.floor((track.clientWidth + 1) / step));
          const cardCount = track.children.length;
          const hasOverflow = maxScroll > 4 || cardCount > visibleApprox;
          prevButton.disabled = !hasOverflow || track.scrollLeft <= 2;
          nextButton.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;
        };

        const scrollByStep = (direction) => {
          const step = getStep();
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const target =
            direction < 0
              ? Math.max(0, track.scrollLeft - step)
              : Math.min(maxScroll, track.scrollLeft + step);
          track.scrollTo({ left: target, behavior: 'smooth' });
          window.setTimeout(updateButtons, 220);
        };

        prevButton.addEventListener('click', () => {
          scrollByStep(-1);
        });
        nextButton.addEventListener('click', () => {
          scrollByStep(1);
        });

        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);
        window.addEventListener('load', updateButtons);
        track.querySelectorAll('img').forEach((img) => {
          if (!img.complete) {
            img.addEventListener('load', updateButtons, { once: true });
          }
        });
        window.requestAnimationFrame(() => {
          updateButtons();
          window.setTimeout(updateButtons, 120);
          window.setTimeout(updateButtons, 420);
        });
      });
    }

    function initProductsCarousel(root) {
      const carousels = root.querySelectorAll('[data-products-carousel]');
      if (!carousels.length) return;

      carousels.forEach((carousel) => {
        const track = carousel.querySelector('[data-products-track]');
        const prevButton = carousel.querySelector('[data-products-prev]');
        const nextButton = carousel.querySelector('[data-products-next]');
        if (!track || !prevButton || !nextButton) return;

        const getStep = () => {
          const firstCard = firstVisibleCard(track);
          if (!firstCard) return 320;
          const style = window.getComputedStyle(track);
          const gap = Number.parseFloat(style.columnGap || style.gap || '0') || 0;
          return Math.max(1, Math.round(firstCard.getBoundingClientRect().width + gap));
        };

        const updateButtons = () => {
          const maxScroll = Math.max(0, Math.ceil(track.scrollWidth - track.clientWidth));
          const step = getStep();
          const visibleApprox = Math.max(1, Math.floor((track.clientWidth + 1) / step));
          const cardCount = track.children.length;
          const hasOverflow = maxScroll > 4 || cardCount > visibleApprox;
          prevButton.disabled = !hasOverflow || track.scrollLeft <= 2;
          nextButton.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;
        };

        const scrollByStep = (direction) => {
          const step = getStep();
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const target =
            direction < 0
              ? Math.max(0, track.scrollLeft - step)
              : Math.min(maxScroll, track.scrollLeft + step);
          track.scrollTo({ left: target, behavior: 'smooth' });
          window.setTimeout(updateButtons, 220);
        };

        prevButton.addEventListener('click', () => {
          scrollByStep(-1);
        });
        nextButton.addEventListener('click', () => {
          scrollByStep(1);
        });

        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);
        window.addEventListener('load', updateButtons);
        track.querySelectorAll('img').forEach((img) => {
          if (!img.complete) {
            img.addEventListener('load', updateButtons, { once: true });
          }
        });
        window.requestAnimationFrame(() => {
          updateButtons();
          window.setTimeout(updateButtons, 120);
          window.setTimeout(updateButtons, 420);
        });
      });
    }

    function initPreordersCarousel(root) {
      const carousels = root.querySelectorAll('[data-preorders-carousel]');
      if (!carousels.length) return;

      carousels.forEach((carousel) => {
        const track = carousel.querySelector('[data-preorders-track]');
        const prevButton = carousel.querySelector('[data-preorders-prev]');
        const nextButton = carousel.querySelector('[data-preorders-next]');
        if (!track || !prevButton || !nextButton) return;

        const getStep = () => {
          const firstCard = firstVisibleCard(track);
          if (!firstCard) return 320;
          const style = window.getComputedStyle(track);
          const gap = Number.parseFloat(style.columnGap || style.gap || '0') || 0;
          return Math.max(1, Math.round(firstCard.getBoundingClientRect().width + gap));
        };

        const updateButtons = () => {
          const maxScroll = Math.max(0, Math.ceil(track.scrollWidth - track.clientWidth));
          const step = getStep();
          const visibleApprox = Math.max(1, Math.floor((track.clientWidth + 1) / step));
          const cardCount = track.children.length;
          const hasOverflow = maxScroll > 4 || cardCount > visibleApprox;
          prevButton.disabled = !hasOverflow || track.scrollLeft <= 2;
          nextButton.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;
        };

        const scrollByStep = (direction) => {
          const step = getStep();
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const target =
            direction < 0
              ? Math.max(0, track.scrollLeft - step)
              : Math.min(maxScroll, track.scrollLeft + step);
          track.scrollTo({ left: target, behavior: 'smooth' });
          window.setTimeout(updateButtons, 220);
        };

        prevButton.addEventListener('click', () => {
          scrollByStep(-1);
        });
        nextButton.addEventListener('click', () => {
          scrollByStep(1);
        });

        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);
        window.addEventListener('load', updateButtons);
        track.querySelectorAll('img').forEach((img) => {
          if (!img.complete) {
            img.addEventListener('load', updateButtons, { once: true });
          }
        });
        window.requestAnimationFrame(() => {
          updateButtons();
          window.setTimeout(updateButtons, 120);
          window.setTimeout(updateButtons, 420);
        });
      });
    }

    function hydratePlatformOfferTracks(root) {
      const tag = root.dataset.homeOffersSearchTag;
      const searchQuery = root.dataset.homeOffersSearchQuery || (tag ? `tag:${tag}` : '');
      const cardBadge = root.dataset.homeOffersCardBadge;
      const limit = Number.parseInt(root.dataset.homeOffersSearchLimit || '12', 10);
      const track = root.querySelector('[data-offers-track]');
      if (!searchQuery || !track || root.dataset.homeOffersSearchLoaded === 'true') return;

      root.dataset.homeOffersSearchLoaded = 'true';
      const query = new URLSearchParams({
        q: searchQuery,
        'resources[type]': 'product',
        'resources[limit]': String(Math.min(Math.max(limit, 5), 10)),
      });

      fetch(`/search/suggest.json?${query.toString()}`, { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          const products = data?.resources?.results?.products;
          if (!Array.isArray(products) || !products.length) return;

          const money = activeMoneyFormatter();
          const fragment = document.createDocumentFragment();

          products.slice(0, limit).forEach((product) => {
            const imageUrl = product.image || product.featured_image?.url;
            const price = Number.parseInt(product.price_min || product.price || '0', 10);
            const compareAtPrice = Number.parseInt(product.compare_at_price_min || '0', 10);
            const hasDiscount = compareAtPrice > price;
            const article = document.createElement('article');
            article.className = 'ecome-home__card ecome-home__card--offer ecome-home__card--store';

            const link = document.createElement('a');
            link.className = 'ecome-home__card-link';
            link.href = product.url;
            link.setAttribute('aria-label', product.title);

            const thumb = document.createElement('div');
            thumb.className = 'ecome-home__thumb';
            if (imageUrl) {
              const image = document.createElement('img');
              image.src = imageUrl;
              image.alt = product.title;
              image.loading = 'lazy';
              thumb.append(image);
            }
            if (cardBadge) {
              const badge = document.createElement('span');
              badge.className = 'ecome-home__sale ecome-home__sale--preorder';
              badge.textContent = cardBadge;
              thumb.append(badge);
            }

            const strip = document.createElement('div');
            strip.className = 'ecome-home__thumb-strip';
            strip.setAttribute('aria-hidden', 'true');
            const dot = document.createElement('span');
            dot.className = 'ecome-home__thumb-dot is-active';
            if (imageUrl) {
              const dotImage = document.createElement('img');
              dotImage.src = imageUrl;
              dotImage.alt = '';
              dotImage.loading = 'lazy';
              dot.append(dotImage);
            }
            strip.append(dot);

            const meta = document.createElement('div');
            meta.className = 'ecome-home__meta';
            const titlePrice = document.createElement('div');
            titlePrice.className = 'ecome-home__title-price';
            const title = document.createElement('h3');
            title.textContent = product.title;
            const priceLine = document.createElement('p');
            priceLine.className = `ecome-home__price${hasDiscount ? ' ecome-home__price--sale' : ''}`;
            const priceStrong = document.createElement('strong');
            priceStrong.textContent = money.format(price);
            if (hasDiscount) priceStrong.style.color = '#dc2626';
            priceLine.append(priceStrong);
            if (hasDiscount) {
              const compare = document.createElement('del');
              compare.textContent = money.format(compareAtPrice);
              priceLine.append(compare);
            }
            titlePrice.append(title, priceLine);
            meta.append(titlePrice);
            link.append(thumb, strip, meta);
            article.append(link);
            fragment.append(article);
          });

          track.replaceChildren(fragment);
          window.dispatchEvent(new Event('resize'));
        })
        .catch(() => {
          root.dataset.homeOffersSearchLoaded = 'failed';
        });
    }

    function parseMoneyAmount(rawValue) {
      if (!rawValue) return null;
      const digits = String(rawValue).replace(/[^\d]/g, '');
      if (!digits) return null;
      const amount = Number.parseInt(digits, 10);
      return Number.isFinite(amount) ? amount : null;
    }

    function formatMoneyAmount(amount) {
      if (!Number.isFinite(amount)) return '';
      return `$${amount.toLocaleString('es-CL')}`;
    }

    function initPriceBadges(root) {
      const cards = root.querySelectorAll(
        '[data-offers-track] .ecome-home__card--store, [data-products-track] .ecome-home__card--store'
      );
      if (!cards.length) return;

      cards.forEach((card) => {
        const titlePrice = card.querySelector('.ecome-home__title-price');
        const priceRow = titlePrice?.querySelector('.ecome-home__price');
        if (!titlePrice || !priceRow) return;
        if (titlePrice.querySelector('.ecome-home__price-badges')) return;

        const saleNode = priceRow.querySelector('strong');
        const compareNode = priceRow.querySelector('del');
        if (!saleNode || !compareNode) return;

        const saleAmount = parseMoneyAmount(saleNode.textContent);
        const compareAmount = parseMoneyAmount(compareNode.textContent);
        if (!Number.isFinite(saleAmount) || !Number.isFinite(compareAmount) || compareAmount <= saleAmount) return;

        const discountAmount = compareAmount - saleAmount;
        const discountPercent = Math.round((discountAmount * 100) / compareAmount);
        if (discountAmount <= 0) return;

        const badgesRow = document.createElement('div');
        badgesRow.className = 'ecome-home__price-badges';
        badgesRow.setAttribute('aria-label', 'Descuento');

        if (discountPercent > 0) {
          const discountBadge = document.createElement('span');
          discountBadge.className = 'ecome-home__price-badge ecome-home__price-badge--discount';
          discountBadge.textContent = `-${discountPercent}%`;
          badgesRow.appendChild(discountBadge);
        }

        const saveBadge = document.createElement('span');
        saveBadge.className = 'ecome-home__price-badge ecome-home__price-badge--save';
        saveBadge.textContent = `Ahorra ${formatMoneyAmount(discountAmount)}`;
        badgesRow.appendChild(saveBadge);

        priceRow.insertAdjacentElement('afterend', badgesRow);
      });
    }

    function initNewTitlesTabs(root) {
      const tabGroups = root.querySelectorAll('[data-new-titles-tabs]');
      if (!tabGroups.length) return;

      tabGroups.forEach((group) => {
        const tabs = Array.from(group.querySelectorAll('[data-new-titles-tab]'));
        const panels = Array.from(group.querySelectorAll('[data-new-titles-panel]'));
        const allLink = group.querySelector('[data-new-titles-all-link]');
        if (!tabs.length || !panels.length) return;

        const activate = (id, focus = false) => {
          tabs.forEach((tab) => {
            const active = tab.dataset.newTitlesTab === id;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
            if (active && focus) tab.focus();
            if (active && allLink && tab.dataset.newTitlesLink) allLink.href = tab.dataset.newTitlesLink;
          });
          panels.forEach((panel) => {
            panel.hidden = panel.id !== id;
          });
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(tab.dataset.newTitlesTab));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let nextIndex = index;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            activate(tabs[nextIndex].dataset.newTitlesTab, true);
          });
        });

        activate(tabs.find((tab) => tab.classList.contains('is-active'))?.dataset.newTitlesTab || tabs[0].dataset.newTitlesTab);
      });
    }

    function initCategoryReveal(root) {
      const grid = root.querySelector('[data-categories-list]');
      const toggle = root.querySelector('[data-categories-toggle]');
      if (!grid || !toggle || toggle.dataset.categoriesReady === 'true') return;

      const extraCards = Array.from(grid.querySelectorAll('[data-category-extra]'));
      const label = toggle.querySelector('[data-categories-toggle-label]');
      if (!extraCards.length || !label) return;

      toggle.dataset.categoriesReady = 'true';

      const setExpanded = (expanded) => {
        grid.dataset.categoriesExpanded = expanded ? 'true' : 'false';
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        label.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;

        extraCards.forEach((card) => {
          card.hidden = !expanded;
        });
      };

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        setExpanded(!expanded);
        if (expanded) toggle.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });

      setExpanded(false);
    }

    /**
     * Las caratulas de los carruseles nacen con loading="lazy", lo que protege
     * la carga inicial de la pagina. El problema es que en un carrusel
     * horizontal el navegador no las descarga hasta que ya las estas
     * arrastrando a la vista, y se ven aparecer.
     *
     * En cuanto el carrusel entra en pantalla las pasamos a eager con
     * prioridad baja: empiezan a bajar de fondo, sin competir con lo critico,
     * y para cuando el usuario desplaza a la derecha ya estan listas.
     */
    function warmCarouselImages(root) {
      if (!root) return;

      // Libera el pintado diferido (content-visibility) antes de que el
      // carrusel entre en pantalla, para que no se vea el hueco en blanco.
      root
        .querySelectorAll('.ecome-home__offers-carousel, .ecome-home__products-carousel')
        .forEach((carousel) => carousel.classList.add('is-warm'));

      const images = root.querySelectorAll('img[loading="lazy"]');
      images.forEach((img) => {
        try {
          if ('fetchPriority' in img) img.fetchPriority = 'low';
          img.loading = 'eager';
        } catch (error) {
          /* si el navegador no lo permite, se queda como estaba */
        }
      });
    }

    /**
     * Los mismos juegos suelen estar de oferta en varias consolas, asi que los
     * carruseles de PS5, PS4, Nintendo y Xbox mostraban el mismo top pero con
     * distinta caratula. Aqui recorremos los carruseles en el orden de la
     * pagina y, si un juego ya salio en uno anterior, lo descartamos y
     * descubrimos una tarjeta de reserva en su lugar.
     *
     * El juego se identifica por el handle sin el sufijo de plataforma:
     * dead-cells-ps4 y dead-cells-xbox-one son el mismo juego.
     */
    const PLATFORM_SUFFIXES = [
      '-nintendo-switch-2',
      '-nintendo-switch',
      '-xbox-series-xs',
      '-xbox-series',
      '-xbox-one',
      '-ps5',
      '-ps4',
      '-switch',
    ];

    function baseGameKey(handle) {
      if (!handle) return '';
      let key = handle.replace(/-preventa$/, '');
      // Hay handles con mas de un sufijo (one-piece-odyssey-ps4-ps5),
      // asi que recortamos hasta que no quede ninguno.
      let recortado = true;
      while (recortado) {
        recortado = false;
        for (const suffix of PLATFORM_SUFFIXES) {
          if (key.endsWith(suffix) && key.length > suffix.length) {
            key = key.slice(0, -suffix.length);
            recortado = true;
            break;
          }
        }
      }
      return key;
    }

    function dedupeCarouselsAcrossPage() {
      const tracks = document.querySelectorAll('[data-offers-track], [data-products-track]');
      if (tracks.length < 2) return;

      const seen = new Set();

      tracks.forEach((track) => {
        const cards = [...track.querySelectorAll('[data-game-handle]')];
        if (!cards.length) return;

        const visibleTarget = cards.filter((c) => !c.hasAttribute('data-card-reserve')).length;
        let shown = 0;

        cards.forEach((card) => {
          const key = baseGameKey(card.getAttribute('data-game-handle'));
          const repetido = key && seen.has(key);

          if (repetido || shown >= visibleTarget) {
            card.hidden = true;
            return;
          }

          card.hidden = false;
          shown += 1;
          if (key) seen.add(key);
        });
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      const roots = document.querySelectorAll('[data-home-ecome-root], [data-testid^="home-ecome-"]');
      if (!roots.length) return;
      dedupeCarouselsAcrossPage();
      document.documentElement.classList.add('ecome-home-scrollbar-hidden');
      document.body.classList.add('ecome-home-scrollbar-hidden');
      roots.forEach((root) => {
        hydratePlatformOfferTracks(root);
        initPriceBadges(root);
        initNewTitlesTabs(root);
        initCategoryReveal(root);
        initHeroCarousel(root);
        runWhenVisible(root.querySelector('[data-offers-carousel]'), () => initOffersCarousel(root));
        runWhenVisible(root.querySelector('[data-products-carousel]'), () => initProductsCarousel(root));
        runWhenVisible(root.querySelector('[data-preorders-carousel]'), () => initPreordersCarousel(root));
        runWhenVisible(root, () => warmCarouselImages(root), '600px 0px');
        runWhenVisible(root, () => initCountdown(root));
      });
    });
  })();
